import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {
    track: (route, router, unitId, date) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('track', route);
            return false
        }
        date = date || store.getters.getDateToday
        let unit = store.getters.getUnitsByIds[unitId]
        let name = consts.routerNames.tracks.unit.main;
        if(consts.typesForTrackByPoints.includes(unit?.type)) {
            name = consts.routerNames.tracks.unit.asset.main
        }
        router.push({
            name,
            params: {
                unitId,
                date,
            },
            query: {}
        })
    },
    trackXid: (route, router, type, trackXid, timeFrom, timeTo, trackColor) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: consts.routerNames.tracks.xid,
            params: {
                unitId,
                date,
                type,
                trackXid,
                timeFrom,
                timeTo,
                trackColor,
            },
            query: {...route.query}
        })
    },
    trackColor: (route, router, trackColor) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: route.name,
            params: {
                ...route?.params,
                trackColor,
            },
            query: {...route.query}
        })
    },
    trackEvent: (route, router, trackEventType, trackEventXid, trackEventTime = null) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackEvent', route);
            return false
        }
        let params = {...route.params, trackEventType, trackEventXid}
        if (params.unitId && params.date && !(params.type && params.trackXid) && trackEventTime) {
            if (consts.app.$isDevelopment) console.warn('trackEvent', route.params);
            const parkings = store.getters.getParkings
                .filter(p => p.unit_id == params.unitId && p.time_start.date == params.date)
            const trips = store.getters.getTrips
                .filter(t => t.unit_id == params.unitId && t.time_start.date == params.date)
            const item = [...trips, ...parkings]
                //.filter(i => i.unit_id == params.unitId && i.time_start.date == params.date)
                .find(i => i.time_start.utc <= trackEventTime && trackEventTime <= i.time_end.utc)
            if (!item) return false
            params = {
                ...params,
                type: item.type,
                trackXid: item.xid,
                timeFrom: item.time_start.utc,
                timeTo: item.time_end.utc,
                trackColor: 'track-color'
            }
        }
        router.push({
            name: consts.routerNames.tracks.event_xid,
            params,
            query: {...route.query}
        })
    },
    trackMoveOnTrack: (route, router, speed) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        let params = {...route?.params}
        if(speed) {
            params.speed = speed
        } else if(params.speed) {
            delete params.speed
        }
        router.push({
            name: route.name,
            params,
            query: {...route.query}
        })
    },
    trackVideoEventPopup: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackVideoEventPopup', route);
            return false
        }
        router.push({
            name: consts.routerNames.tracks.video.event,
            params: {
                ...route.params,
                trackEventType,
                trackEventXid,
            },
        })
    },
    trackVideoRequestPopup: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackVideoEventPopup', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let type = route?.params?.type
        let trackId = route?.params?.trackXid
        router.push({
            name: consts.routerNames.tracks.video.request,
            params: {
                unitId,
                date,
                type,
                trackId,
                trackEventType,
                trackEventXid,
            },
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.tracks.main+' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.tracks.main;
        router.push({
            name: name ,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'tracks/:pathMatch(.*)?',
        name: consts.routerNames.tracks.main,
        redirect: {
            name: consts.routerNames.tracks.date,
            params: {
                date: store.getters.getDateToday
            }
        },
        meta: {
            list: 'TracksList',
            mainRouteName: consts.routerNames.tracks.main,
            showMapInfo: true,
            showMap: true,
            layers: {
                ...consts.defaultSettingsLayers,
                tracks: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/TracksPage.vue'),
        children:[
            {
                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                name: consts.routerNames.tracks.date,
                children: [
                    {
                        path: ':unitId(\\d+)',
                        name: consts.routerNames.tracks.unit.main,
                        children: [
                            {
                                path: 'asset',
                                name: consts.routerNames.tracks.unit.asset.main,
                                meta: {
                                    layers: {
                                        ...consts.defaultSettingsLayers,
                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                        tracks: {visible: false, showInList: false, showLayer: false},
                                        track_by_points: {visible: true, showInList: false, showLayer: true},
                                    },
                                },
                                children: [
                                    {
                                        path: ':index',
                                        name: consts.routerNames.tracks.unit.asset.index,
                                        meta:{
                                            mainRouteName: consts.routerNames.tracks.main,
                                            parentRouteName: consts.routerNames.tracks.unit.asset.main,
                                        },
                                    },
                                ]
                            },
                            {
                                path: ':type(parking|driving)/:trackXid/:timeFrom(\\d+)/:timeTo(\\d+)/:trackColor(track-color)?/:speed(\\d+)?',
                                name: consts.routerNames.tracks.xid,
                                meta:{
                                    mainRouteName: consts.routerNames.tracks.main,
                                    parentRouteName: consts.routerNames.tracks.main,
                                },
                                // props: {
                                // },
                                // components: {
                                // }
                                children:[
                                    {
                                        path: ':trackEventType/:trackEventXid',
                                        name: consts.routerNames.tracks.event_xid,
                                        meta:{
                                            mainRouteName: consts.routerNames.tracks.main,
                                            parentRouteName: consts.routerNames.tracks.xid,
                                        },
                                        // props: {
                                        // },
                                        // components: {
                                        // }
                                        children: [
                                            {
                                                path: 'video-event-popup',
                                                name: consts.routerNames.tracks.video.event,
                                                meta:{
                                                    mainRouteName: consts.routerNames.tracks.main,
                                                    parentRouteName: consts.routerNames.tracks.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'events'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            },
                                            {
                                                path: 'video-request-popup',
                                                name: consts.routerNames.tracks.video.request,
                                                meta:{
                                                    mainRouteName: consts.routerNames.tracks.main,
                                                    parentRouteName: consts.routerNames.tracks.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'requests'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            }
                                        ]
                                    },
                                ]
                            },
                        ]
                    }
                ]
            },
        ]
    },
];

export default routes;